<template>
    <div id="admin-messages">
        <div class="admin-messages-left">
            <div class="admin-message" v-on:click="currentMessage = message; messageRead(message.id)" v-for="message in sortMessages(messages)" :key="message.id">
                <div class="admin-message-wrap">
                    <div class="admin-message-name">{{ message.name }}</div>
                    <div class="admin-message-email">{{ message.email }}</div>
                    <div class="admin-message-date">{{ displayDate(message.date) }}</div>
                    <div v-if="message.read" class="admin-message-read message-read"></div>
                    <div v-else class="admin-message-read message-unread"></div>
                </div>
            </div>
        </div>
        <div class="admin-messages-right">
            <div v-if="currentMessage" class="admin-message-preview-wrap">
                <div class="admin-message-preview-name"><b>Nafn:</b> {{ currentMessage.name }}</div>
                <div class="admin-message-preview-email"><b>Email:</b> {{ currentMessage.email }}</div>
                <div class="admin-message-preview-message"><b>Skilaboð:</b> {{ currentMessage.comment }}</div>
                <div v-if="currentMessage.read" v-on:click="messageUnread(currentMessage.id)" class="admin-message-preview-button">Merkja sem ólesið</div>
                <div v-else v-on:click="messageRead(currentMessage.id)" class="admin-message-preview-button">Merkja sem lesið</div>
            </div>
            <div v-else class="admin-message-preview-none">
                Veldu skilaboð til að skoða
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')
import moment from 'moment'

export default {
    data() {
        return {
            currentMessage: null
        }
    },
    methods: {
        messageUnread(id) {
            fb.db.collection("messages").doc(id).update({
                read: false
            })
            this.currentMessage.read = false
        },
        messageRead(id) {
            fb.db.collection("messages").doc(id).update({
                read: true
            })
            this.currentMessage.read = true
        },
        sortMessages() {
            // Sorts blogs by date and only displays blogs that are published
            var copyMessages = this.messages.slice()
            copyMessages.sort(function(a,b){return Date.parse(b.date) - Date.parse(a.date)})
            return copyMessages
        },
        displayDate: function(timestamp) {
            if (timestamp) {
                timestamp = new Date(timestamp)
            return moment(timestamp).format('DD/MM/YYYY hh:mm')
            } else {
                return "DD/MM/YYYY hh:mm"
            }
        }
    },
    computed: {
        ...mapState(['messages'])
        
    }
}
</script>

<style>
#admin-messages {
    width: 90%;
    margin: 0 auto;
    margin-top: 20px;
    height: 90%;
    display:flex;
}
.admin-messages-left {
    width: 40%;
    background-color: rgb(209, 209, 209);
    height:100%;
    overflow-y: auto;
}
.admin-messages-right {
    width: 60%;
    background-color: white;
    height:100%;
    overflow-y: auto;
}
.admin-message {
    cursor: pointer;
}
.admin-message-wrap {
    padding:5px 20px;
    margin:5px;
    height:50px;
    background-color: white;
    position: relative;
}
.admin-message-name {
    position: absolute;
}
.admin-message-email {
    position: absolute;
    margin-top: 20px;
}
.admin-message-date {
    position: absolute;
    right:0;
    line-height: 50px;
    margin-right: 50px;
}
.admin-message-read {
    position: absolute;
    right:0;
    margin-right: 10px;
    height: 20px;
    width: 20px;
    margin-top: 15px;
    border-radius: 50%;
}
.message-read {
    background-color: #f0f0f0;
}
.message-unread {
    background-color: #b33b3b;
}
.admin-message-preview-none {
    font-size: 30px;
    margin-top: 50px;
}
.admin-message-preview-wrap {
    position: relative;
    padding:50px;
    text-align: left;
    font-size: 20px;
}
.admin-message-preview-name {
    height:50px;
}
.admin-message-preview-email {
    height:50px;
}
.admin-message-preview-message {
    height:50px;
}
.admin-message-preview-button {
    position: absolute;
    right:0;
    top: 0;
    margin-top: 10px;
    margin-right: 10px;
    cursor: pointer;
    height:50px;
    background-color: #b33b3b;
    width:150px;
    line-height: 50px;
    text-align: center;
    color:white;
}
</style>
